import { proforientationRecommendationSelectors } from 'portfolio3/features/proforientation/model/selectors';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const proforientationRecommendationProbesYearsSelector = createSelector(
  [proforientationRecommendationSelectors.probes],
  (proforientationRecommendationProbes) =>
    extractDatesFromNestedItems(
      [proforientationRecommendationProbes],
      [
        {
          type: 'date',
          field: 'unformattedEventDate',
        },
      ],
    ),
);
